<form [formGroup] = "form">
  <h1 *ngIf ="mode ==1" mat-dialog-title> Editing {{data.employee_name}}</h1>
  <h1 *ngIf ="mode ==2" mat-dialog-title> Add Contact </h1>

  <div mat-dialog-content>
    <mat-form-field style="width:90%">
        <mat-label>Name:</mat-label>
        <input matInput formControlName = "employee_name">
      </mat-form-field>

      <mat-form-field style="width:90%">
        <mat-label>Phone:</mat-label>
        <input matInput formControlName = "phone">
      </mat-form-field>

      <mat-form-field style="width:90%">
        <mat-label>Email:</mat-label>
        <input matInput formControlName = "e_mail">
      </mat-form-field>

      <div style="width:90%;margin-bottom: 40px;">
        <mat-label>Inactive Employee:</mat-label>
        <mat-checkbox  style="padding-left: 5px; padding-right: 7px;" formControlName = "inactiveemployee"></mat-checkbox>
      </div>


      <div style="margin-top: 1em; margin-bottom: 1em;">
          <mat-label >Employee Type</mat-label>
          <div>
          <mat-select formControlName = 'employeetype'>
            <mat-option value="Energy Product Specialist">Energy Product Specialist</mat-option>
            <mat-option value="Energy Program Compliance Technician">Energy Program Compliance Technician</mat-option>
            <mat-option value="H: Field Inspector">H: Field Inspector</mat-option>
            <mat-option value="H: Office">H: Office</mat-option>
            <mat-option value="H: Office GPS">H: Office GPS</mat-option>
            <mat-option value="N/A">N/A</mat-option>
            <mat-option value="QI Product Specialist">QI Product Specialist</mat-option>
            <mat-option value="Quality Inspector">Quality Inspector</mat-option>
            <mat-option value="Rater">Rater</mat-option>
            <mat-option value="Regional Manager">Regional Manager</mat-option>
            <mat-option value="S: Field Inspector">S: Field Inspector</mat-option>
            <mat-option value="S: Office">S: Office</mat-option>
            <mat-option value="S: Office GPS">S: Office GPS</mat-option>
            <mat-option value="Sub-Contractor">Sub-Contractor</mat-option>
            <mat-option value="Territory Manager I">Territory Manager I</mat-option>
            <mat-option value="Territory Manager II">Territory Manager II</mat-option>
          </mat-select>
        </div>
        </div>

      <mat-form-field style="width:90%;margin-bottom:1em;">
        <mat-label>Supervisor: {{supervisingratername}}</mat-label>
        <input  #supervising_rater matInput [placeholder]="data.supervisingrater? this.supervisingratername.trim() : '' " formControlName = "supervisingrater" [matAutocomplete] = "employeeauto">
      </mat-form-field>

    <mat-autocomplete #employeeauto = "matAutocomplete" (optionSelected) = "onSelectSupervisor($event.option.value)" [displayWith]="displayFunctionEmployee">
        <mat-option *ngFor="let em of (employee$ | async)" [value]="em">
          <span>{{ em.employee_name}}</span>
        </mat-option>
      </mat-autocomplete>

      <mat-form-field style="width:90%" *ngIf="data.canSeeRaterOfRecord == true">
        <mat-label>Rater of Record</mat-label>
        <input matInput formControlName = "supervisorname">
      </mat-form-field>


      <mat-form-field>
        <mat-label> Region </mat-label>
        <mat-select  formControlName = "region">
          <mat-option *ngFor = "let region of regions" [value] = "region.value">
            {{region.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width:90%; margin-top: 1em; margin-bottom:1em;" >
        <mat-label>Initials:</mat-label>
        <input matInput formControlName = "initials">
      </mat-form-field>
      
      <div *ngIf="canSeeCerts && !data.canEditCerts">
      <div style="padding-top: 2em;">
        <mat-label>Certs Obtained: </mat-label>
       </div> 

        <div style="display: flex;
    flex-direction: column;
    margin-left: 10px;
    padding-bottom: 2em;
    background: #bababa59;
    width: 5em;">

          <div style="display: flex; flex-direction: column;">        
              <mat-checkbox *ngFor="let cert of certifications;" 
              [checked]="isChecked(cert)"
              (change)="onCertSelected($event, cert)" style="color:#424242;" disabled>
              {{cert}}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div *ngIf="data.canEditCerts">
      <div style="padding-top: 2em;">
        <mat-label>Certs Obtained: </mat-label>
       </div> 

        <div style="display:flex; flex-direction:column; margin-left: 10px; padding-bottom: 2em;">

          <div style="display: flex; flex-direction: column;">        
              <mat-checkbox *ngFor="let cert of certifications;" 
              [checked]="isChecked(cert)"
              (change)="onCertSelected($event, cert)">
              {{cert}}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <p>
        <mat-form-field style="padding-right: 40px; width:100%">
          <mat-label>Start Date ({{data.start_date?.substring(0,10)}})</mat-label>
          <input matInput formControlName = 'start_date' [matDatepicker]="start_date" disabled>
          <mat-datepicker-toggle matSuffix [for]="start_date"></mat-datepicker-toggle>
          <mat-datepicker #start_date disabled="false"></mat-datepicker>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field style="padding-right: 40px; width:100%">
          <mat-label>Termination Date ({{data.termination_date?.substring(0,10)}})</mat-label>
          <input matInput formControlName = 'termination_date' [matDatepicker]="termination_date" disabled>
          <mat-datepicker-toggle matSuffix [for]="termination_date"></mat-datepicker-toggle>
          <mat-datepicker #termination_date disabled="false"></mat-datepicker>
        </mat-form-field>
      </p>

    <br>

  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
    <button *ngIf ="mode ==1" mat-button  (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
    <button *ngIf ="mode ==2" mat-button  (click)="add()"  [mat-dialog-close]="data" cdkFocusInitial>Add</button>
  </div>
  </form>
